// extracted by mini-css-extract-plugin
export var accessoireIcon = "style-mod--accessoire-icon--60567";
export var accessoireImg = "style-mod--accessoire-img--b7b16";
export var accessoireImgContainer = "style-mod--accessoire-img-container--ecd7f";
export var accessoireSet = "style-mod--accessoire-set--ff365";
export var accessoireSetDesktop = "style-mod--accessoire-set-desktop--dc049";
export var accessoireSetMobile = "style-mod--accessoire-set-mobile--23951";
export var accessoiresOutOfStock = "style-mod--accessoires-out-of-stock--ab6e2";
export var accessoiresOutOfStockBadge = "style-mod--accessoires-out-of-stock-badge--74626";
export var accessoiresSelected = "style-mod--accessoires-selected--49250";
export var setTextContainer = "style-mod--set-text-container--191a4";
export var variantText = "style-mod--variant-text--54f64";